import { useBoolean } from 'usehooks-ts';

export const usePressable = () => {
	const { value: isFocused, setTrue: onFocus, setFalse: onBlur } = useBoolean(false);
	const { value: isHovered, setTrue: onHoverIn, setFalse: onHoverOut } = useBoolean(false);

	return { isFocused, isHovered, onFocus, onBlur, onHoverIn, onHoverOut };
};
